import { useMemo } from 'react'

import NumericOperatorInput from '@components/NumericOperatorInput/NumericOperatorInput'
import { UrlUpdateType } from 'use-query-params'

type Props = {
	value: string | null
	updateFilters: (changes: any, updateTypeOverride?: UrlUpdateType) => void
}

export default function ExtendedPrice({ value, updateFilters }: Props) {
	const formattedValue = useMemo(() => {
		if (!value) return null
		const [operator, extendedPrice] = value.split('.')
		return { operator, value: extendedPrice }
	}, [value])

	const handleChange = (value: { operator: string; value: string } | null) => {
		if (value) {
			updateFilters({ extendedPrice: `${value.operator}.${value.value}` })
		} else {
			updateFilters({ extendedPrice: null })
		}
	}

	return (
		<NumericOperatorInput
			fullWidth
			size="small"
			label="Extended Price"
			value={formattedValue}
			onChange={handleChange}
		/>
	)
}
